import BaseView from "scripts/views/baseView";
import templateAnthologyPageOverviewSubPage from "templates/anthologyPageOverviewSubPage.hbs";

class AnthologyPageOverviewSubPageView extends BaseView {
  get template() {
    return templateAnthologyPageOverviewSubPage;
  }

  render() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  }

  sync() {
    return this.model.fetch();
  }
}

export default AnthologyPageOverviewSubPageView;
